import { Injectable } from '@angular/core';
import { BaseService } from '@base/base.service';
import { QuestionType } from '../models/question-type.model';

@Injectable()
export class QuestionTypesService extends BaseService<QuestionType> {
  serviceUrl = '/api/question-types';
}
